import { motion } from "framer-motion";
import { EASE, SectionTag, MaskedLine, Counter } from "./Motion";

const stats = [
  { value: 42, suffix: " Cr+", label: "Orders Placed", testid: "stat-counter-orders" },
  { value: 710, prefix: "₹", suffix: " Cr+", label: "Client Value Facilitated", testid: "stat-counter-value" },
  { value: 12000, suffix: "+", label: "Creators & Brands", testid: "stat-counter-creators" },
  { value: 8, suffix: "+", label: "Years of Craft", testid: "stat-counter-years" },
];

export default function Stats() {
  return (
    <section id="impact" data-testid="stats-section" className="relative py-28 sm:py-36">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-16">
        <SectionTag index="01" label="Proof in Numbers" testid="stats-tag" />
        <h2 className="mt-6 text-4xl font-bold tracking-tight text-neutral-50 sm:text-5xl">
          <MaskedLine>Proof, not promises.</MaskedLine>
        </h2>

        <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/5 bg-white/5 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.9, ease: EASE, delay: i * 0.1 }}
              className="group relative bg-[#0A0A0E] p-8 sm:p-10"
            >
              <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent opacity-0 transition-opacity duration-700 group-hover:opacity-100" />
              <Counter
                to={s.value}
                prefix={s.prefix || ""}
                suffix={s.suffix}
                testid={s.testid}
                className="block whitespace-nowrap text-4xl font-bold tracking-tight text-neutral-50 lg:text-5xl"
              />
              <div className="mt-4 font-mono text-[11px] uppercase tracking-[0.25em] text-neutral-500">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
